import { Turbo } from '@hotwired/turbo-rails';
Turbo.session.drive = false;

import Rails from '@rails/ujs';
import copyAndNotify from '@frontend/utils/copy-and-notify';

import CampaignTracking from '@frontend/app/features/CampaignTracking';
import ConvertedWithTracking from '@frontend/app/features/ConvertedWithTracking';
import { clearNotification } from '@components/notification_box/component_controller';
import { display as displayModal } from '@controllers/main/modal-window_controller';

document.addEventListener('DOMContentLoaded', () => {
  if (window._rails_loaded !== true) {
    Rails.start();
  }

  CampaignTracking.init();
  ConvertedWithTracking.init();

  window.Rails = Rails;
  window.kraut = window.kraut || {};
  window.kraut.clearNotification = clearNotification;
  window.kraut.displayModal = displayModal;
  window.kraut.copyAndNotify = copyAndNotify;
});
